import styled from "@emotion/styled";
import { BASE_COLORS } from "../../emotion-theme";

export const Divider = styled.hr`
  border: 0;
  border-top: solid 1px ${BASE_COLORS.lightGrey};
  padding: 0;
  margin: 0;
  width: 100%;
`;
